import { isUndefined } from 'lodash'

export const filterQueryParams = (object: Record<string, any>) => {
  return Object.keys(object).reduce(
    (accumulator, key) => {
      const value = object[key]

      if (!isUndefined(value) && !Number.isNaN(value)) {
        accumulator[key] = object[key]
      }

      return accumulator
    },
    {} as Record<string, any>
  )
}
